import constant from '@constants/constant'

const messageProcessor = {
  messageType: {
    None: 0,
    RuleEngine: 1,
    FileUpload: 2,
  },
  parseMessage: (message) => {
    if (!message) {
      return {
        messageType: 'None',
        message: {},
      }
    }
    let tempObj = message
    if (message.notificationId) {
      try {
        tempObj = JSON.parse(message.message)
      } catch (a) {
        tempObj = {
          displayText: message.message,
          isInvalid: true,
        }
      }

      tempObj.notificationId = message.notificationId
    }

    if (tempObj.isInvalid) {
      return {
        messageType: messageProcessor.messageType.None,
        message: tempObj,
        
      }
    }

    if (tempObj.RuleEngineStatus) {
      tempObj.displayText = `Rule Engine Execution for project ${
        tempObj.RuleEngineStatus.ProjectId
      }  is ${toStatusSz(tempObj.RuleEngineStatus.Status)}`
      return {
        messageType: messageProcessor.messageType.RuleEngine,
        message: tempObj,
      }
    } else {
      tempObj.displayText = `File ${
        tempObj.FileName
      } processing is ${toStatusSz(tempObj.OrderStatus)}`
      return {
        messageType: messageProcessor.messageType.FileUpload,
        message: tempObj,
      }
    }
  },
}

function toStatusSz(code) {
  switch (code) {
    case constant.hmdaNotificationStatus.success:
      return 'Success'
    case constant.hmdaNotificationStatus.failed:
      return 'Failed'
    case constant.hmdaNotificationStatus.partial:
      return 'Partial Failed'
  }
}

export default messageProcessor
